import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const HeroSection = ({ searchQuery, setSearchQuery }) => {
  const trendingTopics = [
    'Subsidies 2026',
    'Warmtepomp kosten',
    'Isolatie tips',
    'Zonnepanelen rendement'
  ];

  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-background to-secondary/10 py-12 sm:py-16 lg:py-20 overflow-hidden">
      <motion.div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: "radial-gradient(circle at 2px 2px, rgba(59, 130, 246, 0.15) 1px, transparent 0)",
          backgroundSize: "40px 40px"
        }}
        animate={{
          backgroundPosition: ["0px 0px", "40px 40px"],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Icon name="Library" size={32} className="text-primary" />
            <span className="text-sm font-caption font-medium text-primary uppercase tracking-wide">
              Kenniscentrum
            </span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            Verduurzamingskennis Hub
          </h1>
          
          <p className="text-lg sm:text-xl font-body text-muted-foreground max-w-3xl mx-auto mb-8">
            Alle informatie, kennis en expert advies over verduurzaming op één plek
          </p>
          
          {/* Search Bar */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="max-w-2xl mx-auto mb-6"
          >
            <div className="relative">
              <Icon 
                name="Search" 
                size={20} 
                className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
              />
              <Input
                type="text"
                placeholder="Zoek naar artikelen, gidsen, tips..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="pl-12 pr-4 py-3 h-12 text-base"
              />
            </div>
          </motion.div>
          
          {/* Trending Topics */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="flex flex-wrap items-center justify-center gap-2"
          >
            <span className="text-sm font-body text-muted-foreground">Populair:</span>
            {trendingTopics?.map((topic, index) => (
              <motion.button
                key={index}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-3 py-1 bg-card border border-border rounded-full text-sm font-body text-foreground hover:bg-primary/10 hover:border-primary transition-colors"
              >
                {topic}
              </motion.button>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;